var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMincAdmin = function SvgMincAdmin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1.-Sidebar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.4-Sidebar-/-All",
    transform: "translate(-1200.000000, -334.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "05.Templates/01.Side-bar/Expand/Clinic-Copy-2",
    transform: "translate(1184.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Health-screening",
    transform: "translate(0.000000, 324.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(16.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.395,4.01812496 C11.786875,3.36156246 10.9375,2.99999996 10,2.99999996 C9.05749999,2.99999996 8.20531249,3.35937496 7.59999998,4.01187496 C6.98812498,4.67156247 6.68999998,5.56812497 6.75999998,6.53624998 C6.89874998,8.44624999 8.35218749,9.99999996 10,9.99999996 C11.6478125,9.99999996 13.09875,8.44656249 13.2396875,6.53687498 C13.310625,5.57749997 13.010625,4.68281247 12.395,4.01812496 Z M15.5,17 L4.49999997,17 C4.20841647,17.0037929 3.93063672,16.8760372 3.74374996,16.6521875 C3.54062496,16.409375 3.45874996,16.0778125 3.51937496,15.7425 C3.78312496,14.279375 4.60624997,13.0503125 5.89999997,12.1875 C7.04937498,11.4215625 8.50531249,11 10,11 C11.4946875,11 12.950625,11.421875 14.1,12.1875 C15.39375,13.05 16.216875,14.2790625 16.480625,15.7421875 C16.54125,16.0775 16.459375,16.4090625 16.25625,16.651875 C16.0694239,16.8758413 15.7916352,17.0037159 15.5,17 Z",
    id: "Combined-Shape",
    fill: "currentColor",
    mask: "url(#mask-2)"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMincAdmin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/minc-admin.95054535.svg";
export { ForwardRef as ReactComponent };